import React, { Component } from 'react';
import Properties from '../item/properties';
import { imageUrl } from 'helpers/ApplicationHelper';
import I18n from 'lib/i18n/i18n';
import { isMobile } from 'helpers/ApplicationHelper';

class SideBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showProperties: false
        };
        this.propsTitle = React.createRef();
    }

    componentDidUpdate() {
        if (!isMobile() && !this.desktopStickyObserver) {
            const observerOptions = {
                root: null,
                rootMargin: '0px',
            };
            const desktopObserverStickyCb = entries => {
                const element = entries[0];
                console.log('===',element.intersectionRatio)
                if (entries.length === 1) {
                    this.setState({
                        stickyBoxStyle: element.intersectionRatio === 0
                    });
                }
            };
            this.desktopStickyObserver = new IntersectionObserver(desktopObserverStickyCb, {
                ...observerOptions,
                threshold: [0, 0.05]
            });
            this.desktopStickyObserver.observe(this.propsTitle.current);
        }
    }

     componentWillUnmount() {
        if (this.desktopStickyObserver) {
            this.desktopStickyObserver.unobserve(this.propsTitle.current);
        }
    }

    onClick() {
        if(isMobile()) {
            this.setState(prevState => ({ showProperties: !prevState.showProperties }));
        }
    }

    render(){
        let subsets = this.props.trends.subsets;
        let asmCount =  Object.keys(subsets).reduce((prev, props) => {return prev + Object.keys(subsets[props].properties).reduce((p, c) => {
            return p + (subsets[props].properties[c].asm == true); 
        }, 0)}, 0);

        return(
            <div id="properties" ref="props" className='properties-section' >
                <div className="mobile-item-desc">
                    <h5 className="item-props-desc" ref={this.propsTitle}>{ this.props.itemDescription }</h5>
                    <div className="arrow-wrapper">
                        <img className={`arrow-${this.state.showProperties ? 'up' : 'down'}`} 
                            src={ isMobile() ? imageUrl('common/arrow.svg') : null } 
                            onClick={() => this.onClick()}
                        />
                    </div>
                </div>
                <div className={`wrap-sticky ${this.state.stickyBoxStyle ? 'sticky' : null}`}>
                    <div className="assumtion">{I18n.getString('itemPage::trends::asmDescription', {asmCount})}</div>
                    { !isMobile() || this.state.showProperties ?
                        <Properties item={this.props.trends || []} showSellerNotes={false} trends={true} />
                        : null
                    }
                    <button id="first" className="btn btn-orange sell-now" onClick={this.props.onClick}>
                        {I18n.getString('itemPage::trends::buttonSellNow')}
                    </button>

                </div>
            </div> 
        )
    }
}

export default SideBar;